import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Employees } from '../components/hrm/Employees';
import { Payroll } from '../components/hrm/Payroll';
import { Withdrawals } from '../components/hrm/Withdrawals';
import { Bonuses } from '../components/hrm/Bonuses';

export const HRM = () => {
  const { t, language } = useLanguage();
  const [searchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'employees';

  return (
    <div className="p-8">
      <h1 className="text-4xl font-bold tracking-tight mb-6" lang={language === 'ar' ? 'ar' : 'en'} data-testid="hrm-title">
        {t('hrm')}
      </h1>

      <Tabs defaultValue={defaultTab} className="w-full">
        <TabsList className="mb-6">
          <TabsTrigger value="employees" data-testid="tab-employees">
            <span lang={language === 'ar' ? 'ar' : 'en'}>{t('employees')}</span>
          </TabsTrigger>
          <TabsTrigger value="payroll" data-testid="tab-payroll">
            <span lang={language === 'ar' ? 'ar' : 'en'}>{t('payroll')}</span>
          </TabsTrigger>
          <TabsTrigger value="withdrawals" data-testid="tab-withdrawals">
            <span lang={language === 'ar' ? 'ar' : 'en'}>{t('withdrawals')}</span>
          </TabsTrigger>
          <TabsTrigger value="bonuses" data-testid="tab-bonuses">
            <span lang={language === 'ar' ? 'ar' : 'en'}>{t('bonuses')}</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="employees">
          <Employees />
        </TabsContent>
        <TabsContent value="payroll">
          <Payroll />
        </TabsContent>
        <TabsContent value="withdrawals">
          <Withdrawals />
        </TabsContent>
        <TabsContent value="bonuses">
          <Bonuses />
        </TabsContent>
      </Tabs>
    </div>
  );
};